import { render, staticRenderFns } from "./TermsandConditions.vue?vue&type=template&id=4a5d88aa&scoped=true&"
import script from "./TermsandConditions.vue?vue&type=script&lang=js&"
export * from "./TermsandConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsandConditions.vue?vue&type=style&index=0&id=4a5d88aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d88aa",
  null
  
)

export default component.exports